import { useQuery } from "react-query";
import { getCoursesSubjects } from "../services/school/courseSubject/getCoursesSubjects";
import { PagedRequestType } from "../types/PagedResults";

export const useGetCoursesSubjectsQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    ["courses-subjects-pagination", JSON.stringify(data)],
    () => getCoursesSubjects(data),
    options?{...options}:{}
  );